import Vue from 'vue';
import VueNotification from 'vue-notification';

Vue.use(VueNotification);
